import React, { useContext } from 'react'
import { Translations } from '../../services/TranslationService.jsx'
import Highlights from './Highlights'
import UpperDetails from './UpperDetails'
import '../../css/Details.scss'
import SuggestedApps from './SuggestedApps.jsx'
import RecommendedIndustries from './RecommendedIndustries.jsx'
import { StateContext } from '../../services/StateService.jsx'
import AlternateVideo from './AlternateVideo.jsx'
import { PDP_DETAILS_ID } from '../../constants/PDPConstants.js'

const Details = ({ detailsRef }) => {
    const translations = useContext(Translations)
    const { productDetails, richContent, detailsZone } = useContext(StateContext)
    const { details } = translations
    const { suggestedApplications } = productDetails || {}

    return (
        <div
            ref={detailsRef}
            className="sps2-pdp_section sps2-pdp_details"
            id={PDP_DETAILS_ID}
        >
            <h2 className="mds-font_header--2a" tabIndex="-1">
                {details}
            </h2>
            <Highlights />
            <UpperDetails />
            {suggestedApplications && <SuggestedApps />}
            {richContent?.recommendedIndustries && <RecommendedIndustries />}
            {detailsZone && detailsZone?.alternateVideo && <AlternateVideo />}
        </div>
    )
}

export default Details
